import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SidenavigationModule } from '@shared/components/sidenavigation/sidenavigation.module';
import { ResponsiveMenuModule } from '@shared/components/responsive-menu/responsive-menu.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from '@valg-shared/components/table/table.module';
import { CdkTableModule } from '@angular/cdk/table';
import { ValgInputModule } from '@valg-shared/components/input/input.module';
import { InputDropdownModule } from '@valg-shared/components/input/input-dropdown/input-dropdown.module';
import { FormsModule } from '@angular/forms';
import { MapModule } from '@shared/components/map/map.module';
import { BarChartModule } from '@shared/components/bar-chart/bar-chart.module';
import { BarChartRendererModule } from '@shared/components/table/renderers/bar-chart-renderer/bar-chart-renderer.module';
import { ResponsiveBarChartRendererModule } from '@shared/components/table/renderers/responsive-bar-chart-renderer/responsive-bar-chart-renderer.module';
import { CardModule } from '@valg-shared/components/card/card.module';
import { BreadcrumbsModule } from '@shared/components/breadcrumbs/breadcrumbs.module';
import { ValgDKSearchModule } from '@shared/components/input/valgdk-search/valgdk-search.module';
import { DetailsMunicipalComponent } from './municipal.component';
import { VotingDetailsModule } from '@shared/components/voting-details/voting-details.module';
import { TopCandidatesModule } from '@shared/components/top-candidates/top-candidates.module';
import { CountStatusModule } from '@shared/components/count-status/count-status.module';
import { ExpandablePartyTableModule } from '@shared/components/expandable-party-list/expandable-party-table.module';
import { PageLayoutModule } from '@shared/components/page-layout/page-layout.module';
import { ReferendumStatusModule } from '@shared/components/cards/referendum-status/referendum-status.module';
import { CoalitionListModule } from '@shared/components/cards/coalition-list/coalition-list.module';
import { ElectoralCoalitionModule } from '@shared/components/cards/electoral-coalition/electoral-coalition.module';
import { CandidateMandatesModule } from '@shared/components/cards/candidate-mandates/candidate-mandates.module';
import { MandatesListModule } from '@shared/components/cards/mandates-list/mandates-list.module';


@NgModule({
  declarations: [
    DetailsMunicipalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    CdkTableModule,
    ValgInputModule,
    InputDropdownModule,
    FormsModule,
    MatIconModule,
    SidenavigationModule,
    ResponsiveMenuModule,
    RouterModule,
    MapModule,
    BarChartModule,
    BarChartRendererModule,
    ResponsiveBarChartRendererModule,
    CardModule,
    BreadcrumbsModule,
    VotingDetailsModule,
    ValgDKSearchModule,
    TopCandidatesModule,
    CountStatusModule,
    ExpandablePartyTableModule,
    PageLayoutModule,
    ReferendumStatusModule,
    CoalitionListModule,
    ElectoralCoalitionModule,
    CandidateMandatesModule,
    MandatesListModule
  ],
  providers: [
    DecimalPipe
  ]
})
export class DetailsMunicipalModule { }
